module.exports = __webpack_public_path__ + "img/es.72d110e1.png";